// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors-0523ec5deb9547bb4625.js";
	// return url for filenames based on template
	return "" + ({"391":"process-details","806":"__federation_expose_routes","870":"process-overview"}[chunkId] || chunkId) + "-" + {"156":"08837e2b4bec2cc6bf5f","242":"bda15e6c4234beb1127b","373":"964a467b1a7323eb06a5","391":"835dc796077c86802be7","402":"201a3da94bb8c6d9e71e","806":"d77345a024eb2e0e7f2e","870":"8a9b98d7927b0aff48ad"}[chunkId] + ".js";
};